import React, { useRef } from "react";
import { BeOptModeEnum, useBeModel } from "../beModel";
import { AppDrawer } from "../../../../components/YhDrawer";
import { FormItemTypeEnum, IYhForm, IYhFormRef } from "../../../../components/YhFormBox/Types";
import { YhForm } from "../../../../components/YhFormBox";
import { branchDs } from "../../../../utils/constants";
import { beService } from "../beService";
import { message } from "antd";
import useGlobalModel from "@/model/globalModel";


export function DetailDrawer() {
    const {
        drawerVisible: visible,
        optMode,
        setDrawerVisible,
        setSelectedRowKeys,
        getSelectedRowData,
        accountBankTypeDs,
        loadData,
        selectedData,
    } = useBeModel();
    const { beLoadDataAll } = useGlobalModel(() => []);
    const formRef = useRef<IYhFormRef>();


    const formConfig: IYhForm = {
        labelCol: { span: 6 },
        disabled: optMode === BeOptModeEnum.DETAIL,
        initialValues: optMode === BeOptModeEnum.ADD ?
            {
                branch: 'main'
            } : {
                ...selectedData,
                enable: selectedData?.enable === 0 ? false : true
            },
        // initialValues: optMode === BeOptModeEnum.ADD ? { branch: 'main' } : getSelectedRowData(),
        items: [
            {
                type: FormItemTypeEnum.Select,
                ds: branchDs,
                fieldLabel: "分支",
                fieldName: "branch",
                disable: optMode === BeOptModeEnum.DETAIL || optMode === BeOptModeEnum.EDIT,
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "版本",
                fieldName: "ver",
                span: 24,
                disable: optMode === BeOptModeEnum.DETAIL || optMode === BeOptModeEnum.EDIT,
                hidden: optMode === BeOptModeEnum.ADD,
            },
            {
                type: FormItemTypeEnum.Switch,
                fieldLabel: "启用",
                fieldName: "enable",
                valuePropName: "checked",
                span: 24,
                // disable: optMode === BeOptModeEnum.DETAIL || optMode === BeOptModeEnum.EDIT,
                hidden: optMode === BeOptModeEnum.ADD,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "编码",
                fieldName: "code",
                disable: optMode === BeOptModeEnum.DETAIL || optMode === BeOptModeEnum.EDIT,
                rules: [{ required: true, message: "编码不能为空" }],
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "名称",
                fieldName: "name",
                span: 24,
                rules: [{
                    required: true,
                    message: "名称不能为空"
                }],
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "法人",
                fieldName: "corporation",
                span: 24,
                rules: [{
                    required: true,
                    message: "法人不能为空"
                }],
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "电话",
                fieldName: "phone",
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "注册地址",
                fieldName: "address",
                span: 24,
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "开户行",
                fieldName: "bank",
                ds: accountBankTypeDs,
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "账户",
                fieldName: "bankAcct",
                span: 24,
            },
            // {
            //     type: FormItemTypeEnum.Switch,
            //     fieldLabel: "状态",
            //     fieldName: "status",
            //     span: 24,
            //     hidden: optMode === BeOptModeEnum.ADD,
            // },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note",
                span: 24,
            }
        ]
    };
    const title = optMode === BeOptModeEnum.ADD ? "新增经营实体"
        : optMode === BeOptModeEnum.EDIT ? "修改经营实体"
            : optMode === BeOptModeEnum.DETAIL ? "经营实体信息"
                : "";
    const okText = optMode === BeOptModeEnum.ADD ? "新增"
        : optMode === BeOptModeEnum.EDIT ? "修改"
            : "";

    const onOk = async () => {
        try {
            let formData = await formRef.current?.validateFields();
            if (formData) {
                let params = {
                    ...formData,
                    enable: formData?.enable === false ? 0 : 1
                }
                if (optMode === BeOptModeEnum.ADD) {
                    let insertRet = await beService.insert(formData);
                    if (insertRet.success) {
                        message.success("新增成功!");
                        setDrawerVisible(false)
                        await loadData();
                        beLoadDataAll()
                    } else {
                        message.success("新增失败!" + insertRet.retMsg);
                    }
                }
                if (optMode === BeOptModeEnum.EDIT) {
                    let updateRet = await beService.update(params);
                    if (updateRet.success) {
                        message.success("修改成功!");
                        setSelectedRowKeys([]);
                        setDrawerVisible(false)
                        await loadData();
                        beLoadDataAll()
                    } else {
                        message.success("修改失败!" + updateRet.retMsg);
                    }
                }

            }
        } catch (e) {
            console.log("数据校验失败");
        }
    }
    const onCancel = () => {
        setDrawerVisible(false);
    }
    const drawerConfig = {
        title,
        visible,
        onOk,
        onCancel,
        okText,
        showFooter: optMode !== BeOptModeEnum.DETAIL
    }
    return (
        <AppDrawer  {...drawerConfig}>
            <YhForm formRef={formRef} {...formConfig} />
        </AppDrawer>
    )
}
